import React, { useState, useEffect } from 'react';
import { Save, User, Activity } from 'lucide-react';
import Swal from 'sweetalert2';

const SetPortfolio: React.FC = () => {
  const [customers, setCustomers] = useState<any[]>([]);
  const [algos, setAlgos] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [isSaving, setIsSaving] = useState(false);
  
  const [formData, setFormData] = useState({
    serial_no: '',
    stock_name: '',
    buy_price: '',
    buy_qty: '',
    sell_price: '',
    sell_qty: '',
    my_holding: '',
    derivative: 'Equity',
    profit_loss: ''
  });

  useEffect(() => {
    // Fetch Active Users
    fetch('https://motilalalgo.com/api/admin/customers')
    // fetch('http://localhost:10001/api/admin/customers')
      .then(res => res.json())
      .then(data => {
        if (data.success) setCustomers(data.users.filter((u: any) => u.login_id));
      });

    // Fetch Active Stocks/Algos
    fetch('https://motilalalgo.com/api/admin/algos')
    // fetch('http://localhost:10001/api/admin/algos')
      .then(res => res.json())
      .then(data => {
        if (data.success) setAlgos(data.algos);
      });
  }, []);

  const handleUserSelect = (e: any) => {
    const user = customers.find(c => c.id === parseInt(e.target.value));
    setSelectedUser(user || null);
  };

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedUser || !formData.stock_name) return Swal.fire('Error', 'Select User and Stock', 'error');

    setIsSaving(true);
    try {
      const res = await fetch('https://motilalalgo.com/api/admin/add-trade', {
      // const res = await fetch('http://localhost:10001/api/admin/add-trade', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: selectedUser.id, ...formData })
      });
      const data = await res.json();
      if (data.success) {
        Swal.fire('Added!', 'Trade details saved for user.', 'success');
        setFormData({
          serial_no: '', stock_name: '', buy_price: '', buy_qty: '', 
          sell_price: '', sell_qty: '', my_holding: '', derivative: 'Equity', profit_loss: ''
        });
      } else Swal.fire('Error', data.error, 'error');
    } catch (error) {
      Swal.fire('Error', 'Server connection failed', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex justify-between">
        <div>
          <h1 className="text-2xl font-black text-slate-800">Set Trade Details</h1>
          <p className="text-sm text-slate-500 mt-1">Manually assign trade records to a user's account.</p>
        </div>
        <Activity size={36} className="text-[#3b36a4]" />
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2 flex items-center gap-2"><User size={14}/> Select Customer</label>
              <select onChange={handleUserSelect} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-800 outline-none">
                <option value="">-- Choose a Customer --</option>
                {customers.map(c => <option key={c.id} value={c.id}>{c.first_name} {c.last_name} (ID: {c.login_id})</option>)}
              </select>
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Select Stock</label>
              <select name="stock_name" value={formData.stock_name} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-800 outline-none">
                <option value="">-- Choose Stock --</option>
                {algos.map(a => <option key={a.id} value={a.symbol}>{a.symbol} ({a.stock_name})</option>)}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Serial No.</label>
              <input type="text" name="serial_no" value={formData.serial_no} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" placeholder="STK..." />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Buy Price (₹)</label>
              <input type="number" name="buy_price" value={formData.buy_price} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Buy Qty</label>
              <input type="number" name="buy_qty" value={formData.buy_qty} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Sell Price (₹)</label>
              <input type="number" name="sell_price" value={formData.sell_price} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Sell Qty</label>
              <input type="number" name="sell_qty" value={formData.sell_qty} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">My Holding</label>
              <input type="number" name="my_holding" value={formData.my_holding} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Derivative</label>
              <input type="text" name="derivative" value={formData.derivative} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Profit/Loss (₹)</label>
              <input type="text" inputMode='text' name="profit_loss" value={formData.profit_loss} onChange={handleChange} className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold" placeholder="- for loss" />
            </div>
          </div>

          <button type="submit" disabled={isSaving} className="w-full bg-[#3b36a4] hover:bg-[#2d2780] text-white font-black py-4 rounded-xl shadow-lg transition-all flex justify-center gap-2">
            <Save size={20} /> {isSaving ? 'Saving...' : 'Save Trade Details'}
          </button>
        </form>
      </div>
    </div>
  );
};
export default SetPortfolio;